module.exports = __webpack_public_path__ + "static/media/icon_capture_white.b8416bf2.png";